import React, { createRef, Fragment, FunctionComponent, useState } from "react";
import combineClasses from "helpers/combine-classes";
import setFileOptions from "app/media/helpers/setFileOptions";
import styles from "./VideoViewer.module.scss";
import VideoViewerContent from "./VideoViewer.interface";
import IconViewer from "components/IconViewer/IconViewer";

const VideoViewer: FunctionComponent<VideoViewerContent> = (props) => {
    const videoUrl = setFileOptions(props.src);
    const video = createRef<HTMLVideoElement>();

    const isAutoplay = props.autoplay ? props.autoplay : false;
    const isLoop = props.loop ? props.loop : false;
    const isSoundButton = props.soundButton ? props.soundButton : false;
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(isAutoplay);
    const isPlayingClass = isPlaying === true ? `${styles.isPlaying}` : undefined;

    const isRroundedClass = props.isRounded ? `${styles.isRounded}` : undefined;

    const toggleVideoHandler = () => {
        const videoCurrent = video.current;
        setIsPlaying(!isPlaying);

        if (videoCurrent) {
            if (!isPlaying) {
                videoCurrent.play();
            } else {
                videoCurrent.pause();
            }
        }
    };

    const toggleMuteHandler = () => {
        const videoCurrent = video.current;
        setIsMuted(!isMuted);

        if (videoCurrent) {
            videoCurrent.muted = !isMuted;
        }
    };

    return (
        <Fragment>

            <div
                className={combineClasses([styles.wrapper, props.className, isRroundedClass])}
                style={{ paddingTop: `${(props.heightRatio * 100).toFixed(2)}%` }}
            >
                {props.src ? (
                    <video
                        className={styles.video}
                        controls={isPlaying}
                        autoPlay={isAutoplay}
                        playsInline={isAutoplay}
                        muted={isMuted}
                        loop={isLoop}
                        ref={video}
                    >
                        <source
                            src={videoUrl}
                            type="video/mp4"
                        />
                        {props.alt}
                    </video>
                ) : null}

                {!isAutoplay && (
                    <div
                        className={combineClasses([styles.button_wrapper, isPlayingClass])}
                        onClick={toggleVideoHandler}
                    >
                        <button
                            type="button"
                            className={styles.button}
                        >
                            {!isPlaying ? (
                                <IconViewer
                                    className={styles.icon}
                                    name="play"
                                />
                            ) : (
                                <IconViewer
                                    className={styles.icon}
                                    name="pause"
                                />
                            )}
                        </button>
                    </div>
                )}

                {isAutoplay && isSoundButton ? (
                    <div
                        className={styles.button_wrapper}
                        onClick={toggleMuteHandler}
                    >
                        <div className={styles.sound_button}>
                            {isMuted ? (
                                <IconViewer
                                    className={styles.sound_icon}
                                    name="sound-off"
                                />
                            ) : (
                                <IconViewer
                                    className={styles.sound_icon}
                                    name="sound-on"
                                />
                            )}
                        </div>
                    </div>
                ) : null}
            </div>
        </Fragment>
    );
};

export default VideoViewer;
